// Address text for display (2026-10-18). ERP stores addresses either as plain text
// ("913 W Stacy Rd\nAllen, TX 75013") or as the Address Template's HTML
// ("913 W Stacy Rd<br>\nAllen, TX 75013<br>\n"). Turning each <br> into a newline
// while keeping the newline that already follows it showed a blank line between
// the street and the city. One line per address part, never an empty line.
export function addressLines(raw) {
  return String(raw || '')
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<[^>]+>/g, '')
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean)
    .join('\n');
}
